// `assignOptions` is the already-narrowed list of pricing options whose override
// carries an `assign`. Options without one never reassign and are not passed in.
export const filterAssignRatesForPinnedCarrier = (assignOptions, overridesById, order) => {
    if (!order?.forward_stocked_status || !order?.carrier_id) {
        return assignOptions;
    }

    return assignOptions.filter(
        (option) => overridesById?.[option?._meta?.override_id]?.assign?.client_id === order.carrier_id
    );
};
